import Banner from './banner'

export type { BannerProps } from './banner-types'

export default Banner
